/**
 * Binding seam for widgets that render inside an agent reply. The composition root (`main.tsx`)
 * configures it with the implementation from `@/features/html-widget`, so `features/chats` mounts
 * inline widgets without importing a sibling feature. Same pattern as `@/lib/chat-mcp`, and like
 * it the default renders nothing, so chats works unconfigured (in tests).
 */
import type { ComponentType } from 'react';

export interface ChatInlineWidgetsBindings {
  /** The inline widgets of one reply. */
  InlineWidgets: ComponentType<{ messageId: string }>;
}

const noneBindings: ChatInlineWidgetsBindings = { InlineWidgets: () => null };

let bindings: ChatInlineWidgetsBindings = noneBindings;

/** Called once at app boot from the composition root. */
export const configureChatInlineWidgets = (next: ChatInlineWidgetsBindings): void => {
  bindings = next;
};

/** Test-only reset. Re-applies the bindings or restores the default. */
export const configureChatInlineWidgetsForTests = (
  next: ChatInlineWidgetsBindings | null,
): void => {
  bindings = next ?? noneBindings;
};

export const getChatInlineWidgets = (): ChatInlineWidgetsBindings => bindings;
